import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const success = response => response;

const error = () => {};

export default file => Vue.$http
    .delete(`Containers/${process.env.GS_BUCKET}/files/${encodePathSegment(file)}`)
    .then(success)
    .catch(error);



// WEBPACK FOOTER //
// ./src/services/storage/del.js